<template>
  <vx-card :title="chartTitle">
    <div class="mt-5">
      <chartjs-component-line-chart :height="250"
                                    :chart-data="chartData"
                                    :options="options"></chartjs-component-line-chart>
    </div>
  </vx-card>
</template>

<script>
  import ChartjsComponentLineChart from "./charts-components/ChartjsComponentLineChart.vue"
  import moment from "moment"
  export default {
    data() {
      return {
        chartTitle: this.$t("Statistics.Performance"),
        options: {
          title: {
            display: true,
            text: this.$t("Statistics.ImpressionsVsClicksVsConversions")
          },
          tooltips: {
            mode: "index",
            intersect: false,
          },
          hover: {
            mode: "nearest",
            intersect: true
          },
          scales: {
            xAxes: [
              {
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: this.$t("Statistics.Day")
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  min: 0,
                  beginAtZero: true
                },
                position: "left",
                id: "y-axis-0"
              },
              {
                ticks: {
                  min: 0,
                  beginAtZero: true
                },
                position: "right",
                id: "y-axis-1"
              },
              {
                ticks: {
                  min: 0,
                  beginAtZero: true
                },
                display: false,
                position: "right",
                id: "y-axis-2"
              }
            ],
          }
        }
      }
    },
    computed: {
      statisticsList: function () {
        return this.$store.state.statistics.dashboard.statistics
      },
      chartData: function () {
        const stats = this.statisticsList
        const dimension = "Date"
        const dates = stats.map((item) => {
          return moment(item.date).format("ll")
        })
        const dimensions = stats.map((item) => {
          return item.id
        })
        const impressions = stats.map((item) => {
          return item.impressions
        })
        const clicks = stats.map((item) => {
          return item.clicks
        })
        const conversions = stats.map((item) => {
          return item.totalConversions
        })
        const data = {
          labels: dimension === "Date" ? dates : dimensions,
          datasets: [
            {
              label: this.$t("Analytics.Impressions"),
              borderColor: "#10163a",
              data: impressions,
              fill: false,
              yAxisID: "y-axis-0",
            }, {
              label: this.$t("Analytics.Clicks"),
              fill: false,
              borderColor: "#e67e22",
              data: clicks,
              yAxisID: "y-axis-1",
            }, {
              label: this.$t("Analytics.Conversions"),
              fill: false,
              borderColor: "#28C76F",
              data: conversions,
              yAxisID: "y-axis-2",
            }
          ]
        }
        return data
      }
    },
    components: {
      ChartjsComponentLineChart
    }
  }
</script>
